/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import '@vueup/vue-quill/dist/vue-quill.snow.css';

// Composables
import { createVuetify } from 'vuetify'

import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'

import locales from './locales'

let themeDefault = 'light'
let savedTheme = localStorage.getItem('vuetify-theme')

// Check to see if Media-Queries are supported
if (window.matchMedia) {
  // Check if the dark-mode Media-Query matches
  if(window.matchMedia('(prefers-color-scheme: dark)').matches){
    // themeDefault = 'dark'
  } else {
    themeDefault = 'light'
  }
} else {
  // Default (when Media-Queries are not supported)
  themeDefault = 'light'
}

if(savedTheme){
  themeDefault = savedTheme
}else{
  localStorage.setItem('vuetify-theme', themeDefault)
}

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  ssr: true,
  locale: {
    adapter: createVueI18nAdapter(locales),
  },
  defaults: {
    global: {
      ripple: false,
    },
  },
  theme: {
    defaultTheme: themeDefault,
    themes: {
      light: {
        colors: {
          // "background": "#FFFFFF",
          // "surface": "#FFFFFF",
          // "surface-bright": "#FFFFFF",
          // "surface-light": "#EEEEEE",
          //"surface-variant": "#737373",
          // "on-surface-variant": "#EEEEEE",
          "primary": "#19a9f0",
          "primary-darken-1": "#0a435f",
          "secondary": "#77c3f4",
          "secondary-darken-1": "#3e6680",
          // "error": "#B00020",
          // "info": "#2196F3",
          // "success": "#4CAF50",
          // "warning": "#FB8C00".
          // "white": "#FFFFFF",
          // "black": "#010101",
          // "light": "#F5F5F5",
          // "dark": "#222222",
        },
      },
      dark: {
        colors: {
          // "background": "#121212",
          // "surface": "#323131",
          // "surface-bright": "#ccbfd6",
          // "surface-light": "#424242",
          // "surface-variant": "#737373",
          // "on-surface-variant": "#424242",
          "primary": "#19a9f0",
          "primary-darken-1": "#0a435f",
          "secondary": "#77c3f4",
          "secondary-darken-1": "#3e6680",
          // "error": "#CF6679",
          // "info": "#2196F3",
          // "success": "#4CAF50",
          // "warning": "#FB8C00",
          // "white": "#FFFFFF",
          // "black": "#010101",
          // "light": "#F5F5F5",
          // "dark": "#222222",
        },
      },
    },
  },
})
